import { Link } from "react-router-dom";
import { articles } from "@/mocks/articles";
import SectionHeading from "@/components/feature/SectionHeading";

export default function ArticlePreview() {
  const list = articles.slice(0, 3);
  return (
    <section className="mx-auto max-w-7xl px-4 md:px-6 py-12 md:py-16">
      <div className="flex items-end justify-between gap-4 flex-wrap">
        <SectionHeading
          eyebrow="GUIDE &amp; REVIEW"
          title="阅读指南与专题"
          desc="从资源查找、APP挑选到题材科普，把韩漫阅读的学问一次讲清楚。"
        />
        <Link
          to="/article"
          className="mb-8 md:mb-10 inline-flex items-center gap-1.5 text-sm text-primary-500 hover:text-primary-600 transition-colors whitespace-nowrap"
        >
          全部文章 <i className="ri-arrow-right-line"></i>
        </Link>
      </div>
      <div className="grid md:grid-cols-3 gap-4">
        {list.map((a) => (
          <Link
            key={a.id}
            to={`/article/${a.id}`}
            className="group rounded-xl overflow-hidden bg-background-100 border border-background-200/70 hover:border-primary-400/60 transition-colors"
          >
            <div className="aspect-[16/9] overflow-hidden">
              <img
                src={a.cover}
                alt={`${a.title} 韩国免费漫画阅读指南`}
                title={a.title}
                className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
              />
            </div>
            <div className="p-4">
              <div className="flex items-center gap-2 text-[11px] text-foreground-600">
                <span className="px-2 py-0.5 rounded-full bg-primary-100/60 text-primary-500 font-bold">{a.category}</span>
                <span>{a.date}</span>
                <span>· {a.readTime}</span>
              </div>
              <h3 className="mt-2.5 font-heading text-sm md:text-base text-foreground-950 leading-snug group-hover:text-primary-500 transition-colors">
                {a.title}
              </h3>
              <p className="mt-2 text-xs text-foreground-600 leading-relaxed line-clamp-2">{a.excerpt}</p>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}